<template>
  <div class="sf-slider">
    <vue-slider ref="slider" v-model="model" v-bind="sliderSettings" :disabled="disabled"/>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';

export default {
  components: { vueSlider },
  props: {
    value: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      size: 0,
      position: 0,
      sliderStyle: {
        height: 4,
        startAnimation: true,
        tooltip: false,
        dotSize: 36,
      },
      sliderThemeStyle: {
        bgStyle: {
          background: 'rgba(0, 0, 0, .2)',
        },
      },
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sliderSettings() {
      return {
        ...this.sliderStyle,
        ...this.sliderThemeStyle,
        ...this.settings,
      };
    },
  },
  mounted() {
    this.size = this.$refs.slider.size;
    this.position = this.$refs.slider.position;

    this.$watch('$refs.slider.size', val => {
      this.size = val;
    });
    this.$watch('$refs.slider.position', val => {
      this.position = val;
    });
  },
  methods: {
    refresh() {
      this.$refs.slider.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.sf-slider /deep/ {
  .vue-slider-horizontal {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .vue-slider-dot-handle {
    position: relative;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 14px;
      padding: 2px;
      border: solid;
      border-width: 0 3px 3px 0;
      display: inline-block;
      transition: all 0.3s;
    }

    &:after {
      right: 8px;
      transform: rotate(-45deg);
    }
    &:before {
      left: 8px;
      transform: rotate(135deg);
    }
  }
}
</style>
